export const API_VERSION = 'x-api-version';
export const AUTHORIZATION = 'Authorization';
export const CONTENT_TYPE = 'Content-Type';
